import * as DrivingTestModule from 'Modules/DrivingTestModule';
import { DrivingTest } from '../EnumTypes/ActionEnumTypes';

const init = () => ({
  type: DrivingTest.GET_SINGLE_SUMMARY_INIT,
});

export const success = (data) => ({
  type: DrivingTest.GET_SINGLE_SUMMARY_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: DrivingTest.GET_SINGLE_SUMMARY_FAILURE,
});

const getSingleSummary = (uuid) => async (dispatch) => {
  dispatch(init());
  try {
    const response = await DrivingTestModule.Connector.getSingleSummary(uuid);
    dispatch(success(response.data));
    return response.data.drivingTest;
  } catch (err) {
    dispatch(failure());
    return false;
  }
};

export default getSingleSummary;
